import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { queryKeys } from "utils/misc";
import { LessonListResponseDto } from "./lessonDtos";
import { rolloutRefetchInterval } from "./catalogueDeployments";
import { CatalogueQuery } from "../components/CatalogueList";

const buildQuery = (params: CatalogueQuery): string => {
  const qs = new URLSearchParams();
  qs.set("locale", params.locale);
  qs.set("page", String(params.page + 1));
  qs.set("limit", String(params.limit));
  if (params.search.trim()) qs.set("search", params.search.trim());
  params.joints.forEach(j => qs.append("joint", j));
  if (params.includeDeleted) qs.set("include_deleted", "true");
  return qs.toString();
};

export const useListLessons = (params: CatalogueQuery) =>
  useQuery<LessonListResponseDto>(
    queryKeys.lessonsList(params),
    async () => {
      // @ts-ignore — v2 endpoint, not in OpenAPI types
      const data = await api.parse(`GET /lessons?${buildQuery(params)}`, { root: supportApiBase });
      return Array.isArray(data) ? { items: data } : (data ?? { items: [] });
    },
    { keepPreviousData: true, refetchInterval: data => rolloutRefetchInterval(data?.items) }
  );
